import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { ConfigurationSettings } from "src/app/models/configuration.settings";

@Injectable({
  providedIn: 'root'
})

export class AgentHistoryService {

  constructor(
    private http : HttpClient,
    private configurationSettings: ConfigurationSettings
  ) { }
  //Get all ActiveAgents
  GetAllActiveAgents(botConfigId: number): Observable<any> {
    return this.http.get(
      this.configurationSettings.agent_history_api_endpoint +
      "/GetActiveAgentDetails/" + botConfigId
    );
  };
  GetHistoryAgents(botConfigId: number, date: string): Observable<any> {
    return this.http.get(
      this.configurationSettings.agent_history_api_endpoint +
      "/GetHistoryAgentDetails/" + botConfigId + "/" + date
    );
  };
  GetAgentChatHistoryDetails(botConfigId: number, selectedAgents: string, startDate: string, endDate: string): Observable<any> {
    const params = new HttpParams()
      .set('botConfigId', botConfigId.toString())
      .set('selectedAgents', selectedAgents)
      .set('startDate', startDate)
      .set('endDate', endDate);

    return this.http.get(
      `${this.configurationSettings.agent_history_api_endpoint}/GetAgentChatHistoryDetails`, { params }
    );
  }
}
